const ITEMS = [
  "Community First",
  "Education Opens Doors",
  "Every Student Matters",
  "Ready to Listen",
  "Stronger Together",
  "A Vision for Vaughan",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-sand bg-cream py-6"
    aria-hidden="true"
  >
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center gap-24 pr-24">
          {ITEMS.map((item) => (
            <span key={item} className="flex items-center gap-24 whitespace-nowrap">
              <span className="font-serif text-lg italic text-stone2 md:text-xl">{item}</span>
              <span className="text-terracotta">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
